import { createContext } from 'react'

export const OfferContext = createContext(null)
